import * as React from "react";
import "./more-maps.css";

export default function MoreMaps(): JSX.Element {
    return (
        <div className="moreMaps">
            <h1>Weitere Karten</h1>
            <p>
                <ul>
                    <li>
                        <a
                            href="https://map.geo.lu.ch/fff"
                            target="_blank"
                            rel="noreferrer"
                        >
                            Fruchtfolgeflächen
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://map.geo.lu.ch/boden/karten"
                            target="_blank"
                            rel="noreferrer"
                        >
                            Bodenkarten
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://www.geo.lu.ch/map/zonenplan"
                            target="_blank"
                            rel="noreferrer"
                        >
                            Nutzungsplanung
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://map.geo.lu.ch/naturinventare/bundesinventare"
                            target="_blank"
                            rel="noreferrer"
                        >
                            Inventare Natur und Landschaft
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://map.geo.lu.ch/schutzverordnungen/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            Schutzverordnungen Natur und Landschaft
                        </a>
                    </li>
                </ul>
            </p>
            <br/>
            <p>
                Siehe <a href="https://geoportal.lu.ch/" target="_blank" rel="noreferrer">Geoportal</a> für weitere Karten.
            </p>
        </div>
    );
}
